import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Fetch announcements from Firebase Firestore
 * Collection: 'announcements'
 * Expected document structure:
 * {
 *   title: string,
 *   description: string (HTML content),
 *   createdAt: timestamp,
 *   isActive: boolean
 * }
 */
export const fetchAnnouncements = async () => {
  try {
    const announcementsRef = collection(db, 'announcements');
    const q = query(
      announcementsRef,
      orderBy('createdAt', 'desc'),
      limit(10)
    );
    
    const querySnapshot = await getDocs(q);
    const announcements = [];
    
    querySnapshot?.forEach((doc) => {
      const data = doc?.data();
      if (data?.isActive !== false) {
        announcements?.push({
          id: doc?.id,
          title: data?.title || 'Untitled Announcement',
          description: data?.description || '',
          createdAt: data?.createdAt?.toDate?.() || new Date(),
          isActive: data?.isActive ?? true
        });
      }
    });
    
    return announcements;
  } catch (error) {
    console.error('Error fetching announcements from Firebase:', error);
    return [];
  }
};

/**
 * Get the latest active announcement
 */
export const getLatestAnnouncement = async () => {
  try {
    const announcements = await fetchAnnouncements();
    return announcements?.[0] || null;
  } catch (error) {
    console.error('Error getting latest announcement:', error);
    return null;
  }
};